<div class="wrapper selenium-role-selector">
    <ng-select
        [items]="items"
        bindLabel="value"
        dropdownPosition="bottom"
        [multiple]="false"
        [hideSelected]="false"
        [searchable]="false"
        [clearable]="false"
        [markFirst]="true"
        placeholder="Select a role"
        [(ngModel)]="selectedItem"
        (change)="selectedItemChange.emit(selectedItem)"
        class="dropdown"
    >
    </ng-select>
    <div class="role-label">Role <app-icon [type]="'Info'"></app-icon></div>
</div>
